/**
 * Mark server-reported empty fields as invalid (SCRUM-1021 follow-up).
 *
 * Returns a NEW validation object with `validation[e.param] = false` for every
 * server error whose `value === ""`. Extracts the block that appeared verbatim in
 * several form containers:
 *
 *   const v = { ...validation };
 *   errors.forEach((e) => { if (e.value === "") v[e.param] = false; });
 *   setValidation(v);
 *
 * Pure — it owns only the field-marking transform. The caller keeps the effect
 * wiring, the toast channel, the loading flag and `clearErrors`. Callable per
 * validation object (e.g. category + subcategory), so it never assumes a single
 * setState.
 */
export function markInvalidFields<T extends Record<string, unknown>>(
  validation: T,
  errors?: Array<{ param: string; value: unknown }>
): T {
  const next: Record<string, unknown> = { ...validation };
  (errors || []).forEach((e) => {
    if (e && e.value === "") next[e.param] = false;
  });
  return next as T;
}

